import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GetIdiomasEnAPI, SetUsuariosNextAssistEnAPI, GetUsuariosNextAssistEnAPI, CrearLicenciaUsuarioNextAssistEnAPI, GetNextAssistBODepartamentosEnAPI } from "../../action/actionCreatorsRequests"
import { MSGOK, traducirPagina } from '../../librerias/funciones'
import {
    SaveOutlined,
    CloseOutlined
} from '@ant-design/icons';

import { Input, Row, Col, Drawer, Tabs,Checkbox } from 'antd';
const { TabPane } = Tabs;

const FichaClienteAssist = ({ props, configApp }) => {
    const [departamentos, setDepartamentos] = React.useState([]);


    const [hayRegistros, setHayRegistros] = React.useState(false);
    const [idiomasLocal, setIdiomasLocal] = React.useState([]);
    const [textoIdioma, setTextoIdioma] = React.useState(1);
    const [ID_LICENCIA, setID_LICENCIA] = React.useState(0);
    const [payLoadLocal, setPayLoadLocal] = React.useState(
        {
            USUARIO: "",
            PWD: "",
            ID_SOCIO: 0,
            ID_IDIOMA: 1,
            ID_TALLER: 0,
            CORREO_RECUPERACION_PWD: "",
            OBSERVACIONES: "",
            NOMBRE_TALLER: "",
            ID_DEPARTAMENTO: 0,
            DISENYO_ESPECIAL: "",
            PROHIBIR_CONSULTAS: false

        }
    )


    const BuscarUsuariosEnAPI = (ID, ID_SOCIO) => {
        GetUsuariosNextAssistEnAPI(1, 1, 1, "A", ID_SOCIO, ID).then((cli) => {
            if (cli.REGISTROS !== undefined)
                if (cli.REGISTROS !== null && cli.REGISTROS.length > 0) {
                    let user = cli.REGISTROS[0];
                    setTextoIdioma(user.ID_IDIOMA);
                    setID_LICENCIA(user.ID);
                    setPayLoadLocal({
                        USUARIO: user.USUARIO,
                        PWD: user.PWD,
                        ID_SOCIO: user.ID_SOCIO,
                        ID_IDIOMA: user.ID_IDIOMA,
                        ID_TALLER: user.ID_TALLER,
                        CORREO_RECUPERACION_PWD: user.CORREO_RECUPERACION_PWD,
                        OBSERVACIONES: user.OBSERVACIONES,
                        NOMBRE_TALLER: user.NOMBRE_TALLER,
                        ID_DEPARTAMENTO: user.ID_DEPARTAMENTO,
                        DISENYO_ESPECIAL: user.DISENYO_ESPECIAL,
                        PROHIBIR_CONSULTAS: user.PROHIBIR_CONSULTAS



                    })
                }
        })
    }



    const GetNextAssistBODepartamentos = (ORDERCOLUM, ORDERDIR, ID, NOMBRE) => {
        GetNextAssistBODepartamentosEnAPI(10000, 1, ORDERCOLUM, ORDERDIR, ID, NOMBRE).then((licencias) => {
            if (licencias !== undefined) {
                if (licencias.REGISTROS !== null && licencias.REGISTROS.length > 0) {
                    setDepartamentos(licencias.REGISTROS);

                } else {
                    setDepartamentos(null)
                }
            }
        })

    }




    if (!hayRegistros && props.ESTADO_FICHA) {
        setHayRegistros(true);

        GetNextAssistBODepartamentos(1, "A", "", "");


        //CLIENTE SELECCIONADO
        if (Object.keys(props.DATOS_CLIENTE).length > 0) {
            payLoadLocal.ID_TALLER = props.DATOS_CLIENTE.Codigo;
            payLoadLocal.NOMBRE_TALLER = props.DATOS_CLIENTE.Razon;

            setPayLoadLocal(payLoadLocal)
        } else {
            BuscarUsuariosEnAPI(props.ID_USUARIO, props.ID_SOCIO)
        }


        GetIdiomasEnAPI().then(idiomas => {
            if (idiomas !== undefined) {
                if (idiomas !== null && idiomas.length > 0) {
                    setIdiomasLocal(idiomas)

                } else {
                    setIdiomasLocal(null)
                }
            }
        })


    } else {
        if (!props.ESTADO_FICHA && hayRegistros) {
            setHayRegistros(false);
            setIdiomasLocal([])
            setTextoIdioma(1)
            setPayLoadLocal({
                USUARIO: "",
                PWD: "",
                ID_SOCIO: 0,
                ID_IDIOMA: 1,
                ID_TALLER: 0,

                CORREO_RECUPERACION_PWD: "",
                OBSERVACIONES: "",
                NOMBRE_TALLER: "",
                ID_DEPARTAMENTO: "",
                DISENYO_ESPECIAL: "",
                PROHIBIR_CONSULTAS: false

            })
        }
    }

    const guardarEstadoFormulario = (e) => {

        const USUARIO = e.target.name === 'USUARIO' ? e.target.value : payLoadLocal.USUARIO;
        const PWD = e.target.name === 'PWD' ? e.target.value : payLoadLocal.PWD;
        const ID_SOCIO = e.target.name === 'ID_SOCIO' ? e.target.value : payLoadLocal.ID_SOCIO;
        const ID_IDIOMA = e.target.name === 'ID_IDIOMA' ? parseInt(e.target.value) : payLoadLocal.ID_IDIOMA;
        const ID_TALLER = e.target.name === 'ID_TALLER' ? parseInt(e.target.value) : payLoadLocal.ID_TALLER;

        const CORREO_RECUPERACION_PWD = e.target.name === 'CORREO_RECUPERACION_PWD' ? e.target.value : payLoadLocal.CORREO_RECUPERACION_PWD;
        const OBSERVACIONES = e.target.name === 'OBSERVACIONES' ? e.target.value : payLoadLocal.OBSERVACIONES;
        const NOMBRE_TALLER = e.target.name === 'NOMBRE_TALLER' ? e.target.value : payLoadLocal.NOMBRE_TALLER;



        const ID_DEPARTAMENTO = e.target.name === 'ID_DEPARTAMENTO' ? parseInt(e.target.value) : payLoadLocal.ID_DEPARTAMENTO;
        const DISENYO_ESPECIAL = e.target.name === 'DISENYO_ESPECIAL' ? e.target.value : payLoadLocal.DISENYO_ESPECIAL;
        const PROHIBIR_CONSULTAS = e.target.name === 'PROHIBIR_CONSULTAS' ? e.target.checked : payLoadLocal.PROHIBIR_CONSULTAS;



        setPayLoadLocal(
            {
                USUARIO: USUARIO,
                PWD: PWD,
                ID_SOCIO: ID_SOCIO,
                ID_IDIOMA: ID_IDIOMA,
                ID_TALLER: ID_TALLER,
                CORREO_RECUPERACION_PWD: CORREO_RECUPERACION_PWD,
                OBSERVACIONES: OBSERVACIONES,
                NOMBRE_TALLER: NOMBRE_TALLER,
                ID_DEPARTAMENTO: ID_DEPARTAMENTO,
                DISENYO_ESPECIAL: DISENYO_ESPECIAL,
                PROHIBIR_CONSULTAS: PROHIBIR_CONSULTAS


            }
        )
    }

    const modificarIdioma = (e) => {
        payLoadLocal.ID_IDIOMA = e;

        setPayLoadLocal(payLoadLocal)
        setTextoIdioma(e)
    }


    const crearUsuario = () => {
        payLoadLocal.ID_SOCIO = props.ID_SOCIO;
        let PAYLOAD = { ...payLoadLocal }
        PAYLOAD.ID = Object.keys(props.DATOS_CLIENTE).length > 0 ? 0 : props.ID_USUARIO;

        if (Object.keys(props.DATOS_CLIENTE).length > 0) {
            PAYLOAD.CIF_TALLER = props.DATOS_CLIENTE.Cif;
            PAYLOAD.RAZON = props.DATOS_CLIENTE.Razon;
            PAYLOAD.DIRECCION = "";
            PAYLOAD.CODIGO_POSTAL = "";
            PAYLOAD.POBLACION = props.DATOS_CLIENTE.Poblacion;
            PAYLOAD.PROVINCIA = "";
            PAYLOAD.PAIS = props.DATOS_CLIENTE.PAIS_LOCAL;
            PAYLOAD.MAIL = payLoadLocal.CORREO_RECUPERACION_PWD;
            PAYLOAD.TELEFONO = props.DATOS_CLIENTE.Telefono;
            PAYLOAD.EMPRESA_SOCIO = "";
            PAYLOAD.ID_SOCIO = props.ID_SOCIO;
            PAYLOAD.PROHIBIR_CONSULTAS = payLoadLocal.PROHIBIR_CONSULTAS;



            //crear
            CrearLicenciaUsuarioNextAssistEnAPI(PAYLOAD).then(usuario => {
                if (usuario !== undefined && usuario !== null && usuario.OK) {
                    MSGOK(traducirPagina("Usuario_creado"));

                    props.ACTUALIZAR_LICENCIAS(1, "A", props.ID_SOCIO)
                    props.TEXTO_BUSCADOR("")
                    props.CERRAR_FICHA(false);

                    //SE LIMPIA EL CLIENTE SELECCIONADO
                    props.DATOS_CLIENTE_SELECCIONADO({})
                }

            })
        } else {
            SetUsuariosNextAssistEnAPI(1, PAYLOAD).then(usuario => {
                if (usuario !== undefined) {
                    if (usuario.OK) {
                        MSGOK(traducirPagina("Usuario_modificado"))

                        props.ACTUALIZAR_LICENCIAS(1, "A", props.ID_SOCIO)
                        props.TEXTO_BUSCADOR("")
                        props.CERRAR_FICHA(false);

                        //SE LIMPIA EL CLIENTE SELECCIONADO
                        props.DATOS_CLIENTE_SELECCIONADO({})
                    }
                }
            })
        }
    }


    return (
        <Drawer
            width={550}
            onClose={() => {
                props.CERRAR_FICHA(false);
                props.DATOS_CLIENTE_SELECCIONADO({})
            }}
            visible={props.ESTADO_FICHA}
            closable={false}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            style={{ zIndex: '9999', color: '#fff' }}>

            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => {
                        props.CERRAR_FICHA(false);
                        props.DATOS_CLIENTE_SELECCIONADO({})
                    }}></CloseOutlined >
                    <div> {props.title}</div>
                </div>

                <div className='itemHeaderDrawer2'>

                </div>
            </div>




            <div className="m-3">
                <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000', height: (configApp.height - 140).toString() + "px", overflow: 'auto' }}>
                    <Col md={12}>
                        <span>{traducirPagina("Usuario")} </span>
                    </Col>
                    <Col md={12}>
                        <span>{traducirPagina("Contrasenia")} </span>
                    </Col>

                    <Col md={12}>
                        <Input name="USUARIO" autocomplete="off" value={payLoadLocal.USUARIO} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>
                    <Col md={12}>
                        <Input name="PWD" type="text" autocomplete="off" value={payLoadLocal.PWD} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>


                    <Col md={24}>
                        <span>{traducirPagina("Idioma")} </span>
                    </Col>
                    <Col md={12}>
                        {idiomasLocal !== null ?
                            <select value={textoIdioma} className="custom-select" name={"ID_IDIOMA"}
                                onChange={(e) => { modificarIdioma(e.target.value); guardarEstadoFormulario(e) }}>
                                {idiomasLocal.length > 0 ?
                                    idiomasLocal.map((idioma) =>
                                        <option key={idioma.ID} value={idioma.ID}>{idioma.NOMBRE}</option>
                                    )
                                    :
                                    null
                                }
                            </select>
                            :
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <h4>{traducirPagina("Info_error_idioma")}</h4>
                            </div>
                        }
                    </Col>
                    <Col md={24}>
                        <span>{traducirPagina("Info_cliente_correo")}</span>
                    </Col>

                    <Col md={24}>
                        <Input name="CORREO_RECUPERACION_PWD" value={payLoadLocal.CORREO_RECUPERACION_PWD} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>

                    <Col md={24}>
                        <span>{traducirPagina("Observaciones")}</span>
                    </Col>

                    <Col md={24}>
                        <Input name="OBSERVACIONES" value={payLoadLocal.OBSERVACIONES} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>

                    <Col md={24}>
                        <span>{traducirPagina("Taller")} </span>
                    </Col>

                    <Col md={24}>
                        <Input disabled={true} name="NOMBRE_TALLER" type="text" autocomplete="off" value={payLoadLocal.NOMBRE_TALLER} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>

                    <Col md={24}>
                        <span>{traducirPagina("Departamento")} </span>
                    </Col>

                    <Col md={24}>
                        {departamentos !== null ?
                            <select value={payLoadLocal.ID_DEPARTAMENTO} className="custom-select" name={"ID_DEPARTAMENTO"}
                                onChange={(e) => { guardarEstadoFormulario(e) }}>
                                <option value="0">{traducirPagina("Seleccione_departamento")}</option>

                                {departamentos.length > 0 ?
                                    departamentos.map((departamento) =>
                                        <option key={departamento.ID} value={departamento.ID}>{departamento.NOMBRE}</option>
                                    )
                                    :
                                    null
                                }
                            </select>
                            :
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <h4>{traducirPagina("Sin_resultados")}</h4>
                            </div>
                        }
                    </Col>


                    <Col md={24}>
                        <span>{traducirPagina("disenio_especial")} </span>
                    </Col>

                    <Col md={24}>
                        <Input name="DISENYO_ESPECIAL" type="text" autocomplete="off" value={payLoadLocal.DISENYO_ESPECIAL} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>



                    <Col md={24} style={{ marginTop: '10px' }}>

                        <Checkbox name="PROHIBIR_CONSULTAS" checked={payLoadLocal.PROHIBIR_CONSULTAS} onChange={(e) => { guardarEstadoFormulario(e) }}>  <span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{"Prohibir generar consultas"} </span> </Checkbox>


                    </Col>



                </Row>
                <div style={{ flexGrow: '6', textAlign: 'right' }} >
                    <button className="activebtnMenu2" style={{ height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color: '#000', cursor: 'pointer', padding: '0px 20px' }} onClick={(e) => { crearUsuario() }}><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Guardar_salir").toUpperCase()} </span>  </button>
                </div>
            </div>
        </Drawer>
    )
}

FichaClienteAssist.propTypes = {
    title: PropTypes.string,
    ESTADO_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    DATOS_CLIENTE_SELECCIONADO: PropTypes.func,
    ID_SOCIO: PropTypes.number,
    ID_USUARIO: PropTypes.number,
    DATOS_CLIENTE: PropTypes.object,
    ACTUALIZAR_LICENCIAS: PropTypes.func,
    TEXTO_BUSCADOR: PropTypes.func,

};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado,
        VehiculoTallerSeleccionado: state.VehiculoTallerSeleccionado,
        datosFacturacion: state.datosFacturacion
    };
}

export default connect(mapStateToProps)(FichaClienteAssist);